module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "structureObjectForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('h4', [_vm._v("Attachment " + _vm._s(_vm.structureDto.attachmentNumber) + " of " + _vm._s(_vm.attachmentCount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Attachment ID:")]), _vm._v(" " + _vm._s(_vm.structureDto.dbNumber) + "\n                ")])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Attachment Selection:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qaqcSelection.attachmentSelection),
      expression: "qaqcSelection.attachmentSelection"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.qaqcSelection, "attachmentSelection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": -1
    }
  }, [_vm._v("Attachment Selection")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Add As New Production Attachment")]), _vm._v(" "), _vm._l((_vm.productionAttachmentList), function(attachment) {
    return _c('option', {
      domProps: {
        "value": attachment.structureObjectFormId
      }
    }, [_vm._v("Update Production Attachment: " + _vm._s(attachment.dbNumber))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.historicName')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historic Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.historicName),
      expression: "structureDto.historicName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "historicName"
    },
    domProps: {
      "value": (_vm.structureDto.historicName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "historicName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.historicName')),
      expression: "errors.has('structureObjectForm.historicName')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.historicName')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicName',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Other Common Names")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.otherCommonNames),
      expression: "structureDto.otherCommonNames"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.structureDto.otherCommonNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "otherCommonNames", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'otherCommonNames',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.structureType')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Type of Structure/Object")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.structureType),
      expression: "structureDto.structureType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "structureType"
    },
    domProps: {
      "value": (_vm.structureDto.structureType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "structureType", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.structureType')),
      expression: "errors.has('structureObjectForm.structureType')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.structureType')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'structureType',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Associated Resources")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.associatedResources),
      expression: "structureDto.associatedResources"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.structureDto.associatedResources)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "associatedResources", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'associatedResources',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Construction History")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'constructionDateList',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.constructionDates), function(date, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(date.constructionDateTypeDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.isEstimate ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.source))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.removeConstructionDate(index)
        }
      }
    })])])
  }))])], 1)]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-10"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].open()
      }
    }
  }, [_vm._v("Add Construction Dates")])])]) : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "constructionDateModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Construction Dates")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "constructionForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.constructionDateTypeId')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.constructionDateTypeId),
      expression: "constructionDateDto.constructionDateTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "constructionDateTypeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.constructionDateDto, "constructionDateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.constructionDateTypes), function(dateType) {
    return _c('option', {
      domProps: {
        "value": dateType.constructionDateTypeId
      }
    }, [_vm._v("\n                                            " + _vm._s(dateType.description) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.constructionDateTypeId')),
      expression: "errors.has('constructionForm.constructionDateTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.date')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.date),
      expression: "constructionDateDto.date"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "date"
    },
    domProps: {
      "value": (_vm.constructionDateDto.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.date')),
      expression: "errors.has('constructionForm.date')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Estimated")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-2"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.isEstimate),
      expression: "constructionDateDto.isEstimate"
    }],
    attrs: {
      "id": _vm.qaqcFieldId + 'sofEstimateCB',
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.constructionDateDto.isEstimate) ? _vm._i(_vm.constructionDateDto.isEstimate, null) > -1 : (_vm.constructionDateDto.isEstimate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.constructionDateDto.isEstimate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.constructionDateDto.isEstimate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.constructionDateDto.isEstimate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.constructionDateDto, "isEstimate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.qaqcFieldId + 'sofEstimateCB'
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.comment')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.comment),
      expression: "constructionDateDto.comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "comment"
    },
    domProps: {
      "value": (_vm.constructionDateDto.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "comment", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.comment')),
      expression: "errors.has('constructionForm.comment')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionForm.source')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.source),
      expression: "constructionDateDto.source"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "source"
    },
    domProps: {
      "value": (_vm.constructionDateDto.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('constructionForm.source')),
      expression: "errors.has('constructionForm.source')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Required")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesDone()
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3 pull-right",
    attrs: {
      "name": "buttonMore"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesMore()
      }
    }
  }, [_vm._v("More")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.architectBuilder')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Architect(s)/Builder(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.architectBuilder),
      expression: "structureDto.architectBuilder"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "architectBuilder"
    },
    domProps: {
      "value": (_vm.structureDto.architectBuilder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "architectBuilder", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.architectBuilder')),
      expression: "errors.has('structureObjectForm.architectBuilder')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.architectBuilder')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'architectBuilder',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.historicFunctions')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historic Function(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.historicFunctions),
      expression: "structureDto.historicFunctions"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "historicFunctions"
    },
    domProps: {
      "value": (_vm.structureDto.historicFunctions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "historicFunctions", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.historicFunctions')),
      expression: "errors.has('structureObjectForm.historicFunctions')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.historicFunctions')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicFunctions',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.alterations')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Alterations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.alterations),
      expression: "structureDto.alterations"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "alterations"
    },
    domProps: {
      "value": (_vm.structureDto.alterations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "alterations", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.alterations')),
      expression: "errors.has('structureObjectForm.alterations')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.alterations')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'alterations',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.currentUses')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Current use(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.currentUses),
      expression: "structureDto.currentUses"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "currentUses"
    },
    domProps: {
      "value": (_vm.structureDto.currentUses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "currentUses", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.currentUses')),
      expression: "errors.has('structureObjectForm.currentUses')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.currentUses')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'currentUses',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.historicUses')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historic use(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.historicUses),
      expression: "structureDto.historicUses"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "historicUses"
    },
    domProps: {
      "value": (_vm.structureDto.historicUses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "historicUses", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.historicUses')),
      expression: "errors.has('structureObjectForm.historicUses')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.historicUses')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'historicUses',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.description')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'description',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.description),
      expression: "structureDto.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "name": "description"
    },
    domProps: {
      "value": (_vm.structureDto.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.description')),
      expression: "errors.has('structureObjectForm.description')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.description')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.constructionMaterials')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Construction Materials")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.constructionMaterials),
      expression: "structureDto.constructionMaterials"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "constructionMaterials"
    },
    domProps: {
      "value": (_vm.structureDto.constructionMaterials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "constructionMaterials", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.constructionMaterials')),
      expression: "errors.has('structureObjectForm.constructionMaterials')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.constructionMaterials')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'constructionMaterials',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('structureObjectForm.styleType')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Style/Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.styleType),
      expression: "structureDto.styleType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.structureDto.isNonExtant
      }),
      expression: "{ required: !structureDto.isNonExtant }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "styleType"
    },
    domProps: {
      "value": (_vm.structureDto.styleType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "styleType", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('structureObjectForm.styleType')),
      expression: "errors.has('structureObjectForm.styleType')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('structureObjectForm.styleType')))])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'styleType',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Additional Narrative")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'additionalNarrative',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.additionalNarrative),
      expression: "structureDto.additionalNarrative"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.structureDto.additionalNarrative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.structureDto, "additionalNarrative", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'isNonExtant',
      "hasAppend": false
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.structureDto.isNonExtant),
      expression: "structureDto.isNonExtant"
    }],
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "checkbox",
      "id": _vm.qaqcFieldId + 'sofIsNonExtant'
    },
    domProps: {
      "checked": Array.isArray(_vm.structureDto.isNonExtant) ? _vm._i(_vm.structureDto.isNonExtant, null) > -1 : (_vm.structureDto.isNonExtant)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.structureDto.isNonExtant,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.structureDto.isNonExtant = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.structureDto.isNonExtant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.structureDto, "isNonExtant", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label text-label",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "for": _vm.qaqcFieldId + 'sofIsNonExtant'
    }
  }, [_vm._v("Non-Extant")])], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.currentAttachmentNumber === 1
    },
    on: {
      "click": _vm.previousStructureObject
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), (!(_vm.formDisabled)) ? _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.formDisabled
    },
    on: {
      "click": function($event) {
        _vm.qaqcEnabled ? _vm.completeSection('structureObject') : _vm.saveStructureObject()
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.dtoIsNew || _vm.currentAttachmentNumber >= _vm.attachmentCount
    },
    on: {
      "click": _vm.nextStructureObject
    }
  }, [_vm._v("Next")])])]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'structureObject',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Estimated")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba142c8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/HistoricStructureObjectForm.vue
// module id = 989
// module chunks = 1